﻿import document from 'document';
import { eventBus } from '../../foundation/eventBus';
import { events as formEvents } from '../../feature/form/enable-form';

export const finishRegistration = () => {
    const _disableRegistrationButton = async () => {
        const element = document.getElementById('saveDetailsBtn');
        element.disabled = true;
    }

    const init = () => {
        eventBus.subscribe(formEvents.formSubmitted, (data) => {
            if (data.isValidForm && window.location.pathname === '/finish-registration') {
                _disableRegistrationButton();
            }
        });
    };

    return {
        init
    };
};